import React from 'react';
import './CreateSubCategory.css';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import cimage from '../../images/burger/b1.png';

import Pagination from 'react-js-pagination';

const CreateSubCategory = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [categories, setCategories] = useState([]);

  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const ItemCodeOptions = [

    { value: 'Burger', label: 'Burger' },
    { value: 'Briyani', label: 'Briyani' },
    { value: 'Breakfast', label: 'Breakfast' },
    // Add more options as needed
  ];
  
  const [DeleteId, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    e_name: "",
    e_email: "",
    profile: null,
    e_role: "",
    
  });
const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});
const [updatedForm, setUpdatedForm] = useState({
  sub_category_name: "",
  sub_category_code: "",
  sub_category_image: null,
  shop_id:'',
  category_id: '',
  is_active:'',
  category_name:'',
  id:''
});

const [isUpdate, setUpdate] = useState(false); // Controls the update modal visibility
const handleEditCategory = (item) => {
  setUpdatedForm({
    shop_id: item.shop_id || "",
    id: item.id || "",

    sub_category_name: item.sub_category_name || "",
    sub_category_code: item.sub_category_code || "",
    sub_category_image: item.sub_category_image, // Assume no file initially, unless provided by item
    category_id: item.category_id || null,
    category_name:item.category_name,
    is_active:item.is_active
  });
  setUpdate(true); // Open update modal
};



console.log(formData)
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); // Number of items per page
const [searchTerm, setSearchTerm] = useState('');

// Filtering tables based on search term
const filteredTables = tables.filter((item) => {
  return (
    item.category_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.sub_category_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.sub_category_code.toLowerCase().includes(searchTerm.toLowerCase())
  );
});

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
const totalItems = filteredTables.length;

const handleSearchInput = (event) => {
  setSearchTerm(event.target.value);
  setCurrentPage(1); // Reset to the first page when search changes
};

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};
//change the role
const handleCodeSelectChange = (selectedItem) => {
  console.log("selectedItem", selectedItem);
  const role = selectedItem.value;
  setFormData({ ...formData, e_role: role });
};

const handleInputChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
};

const handleImageChange = (e) => {
  setFormData({ ...formData, profile: e.target.files[0] });
};
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
    useEffect(() => {
        fetchTables();
        fetchCategories();
      }, []);

      const fetchCategories = async () => {
        setLoading(true);
        // const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}category-master/get`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setCategories(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
          setTables([])
        }
      };


      const fetchTables = async () => {
        setLoading(true);
        // const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}sub-category-master/get`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
           if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
          setTables([])
        }
      };
      
      

    

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];
      
      

     //search the transaction data
     const filteredSuppliers = tables && tables.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      return (
        (order.e_name && order.e_name.toString().toLowerCase().includes(searchLower)) ||
        (order.e_email && order.e_email.toString().toLowerCase().includes(searchLower))  ||
        (order.e_phone && order.e_phone.toString().toLowerCase().includes(searchLower))  ||
        (order.e_role && order.e_role.toString().toLowerCase().includes(searchLower)) 
      );
    });






 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  
   const resetForm = () => {
    setFormData({
      e_name: "",
      e_email: "",
      profile: null,
      e_role: "",
    });
    setCreate(false);
  };


const handleUpdateSubmit = async (event) => {
  event.preventDefault();
  const formData = new FormData();
  formData.append("sub_category_name", updatedForm.sub_category_name);
  formData.append("sub_category_code", updatedForm.sub_category_code);
  formData.append("sub_category_image", updatedForm.sub_category_image);
  formData.append("category_id", updatedForm.category_id);
  formData.append("category_name", updatedForm.category_name);
  formData.append("is_active", updatedForm.is_active);
  formData.append("shop_id", updatedForm.shop_id);



  try {
    const token=localStorage.getItem('Token');
    const response = await axios.put(`${var_api}/sub-category-master/put/${updatedForm.id}`, formData,{
      headers:{
        Authorization:`${token}`
      }
    });
    Swal.fire("Success", "Sub-Category  updated successfully!", "success");

    console.log("Updated successfully", response.data);
    setUpdate(false); // Close modal
    fetchTables(); // Refresh list
  } catch (error) {
    Swal.fire("Error", `${error.response.data.error}`, "error");
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error updating data:", error);
    }
  } 
};

      //post the form data
      const Submit = async (e) => {
        e.preventDefault();
        setPostLoading(true);
    
        // Creating the payload
        const payload = new FormData();
        const shop_id=localStorage.getItem('ShopId');

        payload.append("shop_id", shop_id);
        payload.append("category_id", formData.e_role); // Selected category ID
        payload.append("category_name", categories.find(cat => cat.id === formData.e_role)?.category_name || "");
        payload.append("sub_category_name", formData.e_name);
        payload.append("sub_category_code", formData.e_email);
        if (formData.profile) {
          payload.append("sub_category_image", formData.profile);
        }
        payload.append("is_active", 1);
    
        try {
          const token=localStorage.getItem('Token');
          const response = await axios.post(`${var_api}sub-category-master/post`, payload, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization:`${token}`
            },
          });
    
          console.log("Response:", response.data);
          resetForm();
          fetchTables();
          setCreate(false);
          Swal.fire({
            icon: "success",
            title: "Sub-category Created!",
            text: "Sub-category created successfully!.",
            confirmButtonText: "OK",
          });
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error creating data:", error);
          }
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `${error.response.data.error}`,
            confirmButtonText: "OK",
          });
        } finally {
          setPostLoading(false);
        }
      };




   

      

     //delete method for remove UOM
     const handleDeleteEmployeee = (id) => {
      setEmployeeD({id});
      setShow(true);
    };


    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('Token');
      axios.delete(`${var_api}sub-category-master/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchTables(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "Sub Category removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Employee not found");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error deleting data:", error);
          }
          Swal.fire("Error", `${error.response.data.message}`, "error");
        });
    };

    //Function for open the update modal
    const handleUpdateEmployee = () =>{
      setIsEdit(true);
    //   console.log("data",data)
    //   setUpdateFormData({
    //       id:data.id,
    //       e_name: data.e_name, 
    //       e_email: data.e_email, 
    //       e_password: data.e_password,
    //       e_phone: data.e_phone,
    //       e_role: data.e_role,
    //       profile: data.e_profile,
    //       shops: data.shops
    //   })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
    }
    




 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


//update method for employee
//post method for updating the food

const handleToggle = (isChecked, item) => {
  const formData = new FormData();
formData.append('shop_id', item.shop_id);
formData.append('category_name', item.category_name);
formData.append('category_id', item.category_id);
formData.append('sub_category_name', item.sub_category_name);

formData.append('sub_category_code', item.sub_category_code);
formData.append('is_active', isChecked ? 1 : 0);
formData.append('sub_category_image', item.sub_category_image); // File from input


  // const updatedData = {   sub_category_code
  //   shop_id: item.shop_id,
  //   category_name: item.category_name,
  //   category_image: item.category_image,

  //   category_code: item.category_code,
  //   is_active: isChecked ? 1 : 0, // Convert boolean to 1 or 0
  // };
  const token=localStorage.getItem('Token');
  axios
    .put(`${var_api}sub-category-master/put/${item.id}`, formData,{
      headers:{
        Authorization:`${token}`
      }}
    )
    .then((response) => {
      if (response.status === 200) {
        Swal.fire("Success", "Sub-Category status updated successfully!", "success");
          fetchTables();
     
      } else {
        Swal.fire("Error", "Failed to update category status!", "error");
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error);
      }
      Swal.fire("Error", `${error.response.data.error}`, "error");
    });
};

 
  




    return(
      <>         <Layout>


            <div class="splitcsc">
          
      <div style={{border:"none",padding:"15px",width:"105%",minHeight:"630px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
    
      <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Sub Category</Button>{' '}
      
      <div>
    
     
       <div class="row">
         <div class="col">
         <h4 className='ushe'>SUB CREATE CATEGORY</h4>
         </div>
       
         <div class="col">
         <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
      style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
         </div>
        
       </div>
    <br/>
      <div className="table-container" style={{ maxHeight:"540px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Category Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Sub Category Image</th>

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Sub Category Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Code</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
          <div className="loader-containeru">
            <div className="spinneru"></div>
          </div>
        ) : (
          <tbody className="body-half-screen">
            {currentItems.length === 0 ? (
              <tr>
                <td colSpan="7"  style={{ textAlign: "center", color: "gray" }}>
                  No Data Available
                </td>
              </tr>
            ) : (
              currentItems.map((item, index) => (
                <tr style={{ padding: '7px' }} key={index}>
                  <th scope="row" style={{ textTransform: 'capitalize', textAlign: 'left' }}>
                    {indexOfFirstItem + index + 1}
                  </th>
                  <td style={{ textTransform: 'capitalize', textAlign: 'left' }}>
                    {item.category_name}
                  </td>
                  <td style={{ textTransform: 'capitalize', textAlign: 'left' }}>
                    <img
                      src={`${image_api}/${item.sub_category_image}`}
                      alt="profile"
                      style={{ width: '75px', height: '65px', objectFit: 'cover' }}
                    />
                  </td>
                  <td style={{ textTransform: 'capitalize', textAlign: 'left' }}>
                    {item.sub_category_name}
                  </td>
                  <td style={{ textTransform: 'capitalize', textAlign: 'left' }}>
                    {item.sub_category_code}
                  </td>
                  <td style={{ textAlign: 'left' }}>
                    <div className="form-check form-switch" style={{ display: 'flex', justifyContent: 'left' }}>
                    <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={item.is_active === 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleToggle(e.target.checked, item)}
            />
                    </div>
                  </td>
                  <td style={{ textAlign: 'left' }}>
                    <i
                      className="bi bi-pencil-square"
                      onClick={() => handleEditCategory(item)}
                      style={{ fontSize: '20px', color: 'rgb(9, 97, 9)' }}
                    ></i>{' '}
                    <i
                      className="bi bi-trash"
                      onClick={() => handleDeleteEmployeee(item.id)}
                      style={{ fontSize: '21px', color: 'rgb(175, 2, 2)' }}
                    ></i>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        )}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Sub Category Name 
          <span style={{color:"red",textTransform:"uppercase"}}> </span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

     

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Sub Category </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form className="py-2" onSubmit={Submit}>
      <div className="row">
        <div className="col">
          <label htmlFor="input5" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Select category
          </label>
          <Select
  options={categories.map((category) => ({
    label: category.category_name,
    value: category.id,
  }))}
  placeholder="Select Category"
  onChange={handleCodeSelectChange}
  isSearchable={true}
  className="customSelect mb-3"
  styles={{
    control: (provided) => ({
      ...provided,
      minWidth: "350px",
      minHeight: "50px",
      borderRadius: "10px",
    }),
  }}
/>

        </div>
        <div className="col">
          <label htmlFor="input1" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Sub Category Name
          </label>
          <input
            type="text"
            className="form-control"
            id="floatingInput"
            placeholder="Category Name"
            name="e_name"
            value={formData.e_name}
            onChange={handleInputChange}
            style={{ borderRadius: "10px", height: "50px" }}
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col">
          <label htmlFor="input2" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Sub Category Code
          </label>
          <input
            type="text"
            className="form-control"
            id="floatingInput"
            placeholder="Category Code"
            name="e_email"
            value={formData.e_email}
            onChange={handleInputChange}
            style={{ borderRadius: "10px", height: "50px" }}
            required
          />
        </div>
        <div className="col">
          <label htmlFor="input5" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Sub Category Image{" "}
          </label>
          <input
            type="file"
            className="form-control"
            id="formFile"
            onChange={handleImageChange}
            name="profile"
            style={{ borderRadius: "10px", height: "50px" }}
          />
        </div>
      </div>
      <br />
      <div className="text-center">
        {postloading ? (
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
        ) : (
          <button
            className="btn btn-success"
            style={{ borderRadius: "10px", float: "right", marginTop: "6px" }}
            disabled={postloading}
          >
            Create
          </button>
        )}
      </div>
    </form>
          <button className="btn btn-danger" onClick={()=>resetForm()} style={{borderRadius:"10px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 
      <Modal
  show={isUpdate}
  onHide={() => setUpdate(false)}
  backdrop="static"
  keyboard={false}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Update Sub Category</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <form className="py-2" onSubmit={handleUpdateSubmit}>
      <div className="row">
        <div className="col">
          <label htmlFor="input5" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Select Category
          </label>
          <Select
  options={categories.map((category) => ({
    label: category.category_name,
    value: category.id, // Store the category ID, not the name
  }))}
  placeholder="Select Category"
  onChange={(selectedOption) =>
    setUpdatedForm({
      ...updatedForm,
      category_name: selectedOption.label, // Store the category name
      category_id: selectedOption.value,  // Store the category ID
    })
  }
  value={categories
    .map((category) => ({
      label: category.category_name,
      value: category.id,
    }))
    .find((category) => category.label === updatedForm.category_name) || null} // Match by category_name
  isSearchable={true}
  className="customSelect mb-3"
  styles={{
    control: (provided) => ({
      ...provided,
      minWidth: "350px",
      minHeight: "50px",
      borderRadius: "10px",
    }),
  }}
/>

        </div>
        <div className="col">
          <label htmlFor="input1" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Sub Category Name
          </label>
          <input
            type="text"
            className="form-control"
            id="floatingInput"
            placeholder="Category Name"
            name="sub_category_name"
            value={updatedForm.sub_category_name}
            onChange={(e) =>
              setUpdatedForm({ ...updatedForm, sub_category_name: e.target.value })
            }
            style={{ borderRadius: "10px", height: "50px" }}
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col">
          <label htmlFor="input2" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Sub Category Code
          </label>
          <input
            type="text"
            className="form-control"
            id="floatingInput"
            placeholder="Category Code"
            name="sub_category_code"
            value={updatedForm.sub_category_code}
            onChange={(e) =>
              setUpdatedForm({ ...updatedForm, sub_category_code: e.target.value })
            }
            style={{ borderRadius: "10px", height: "50px" }}
            required
          />
        </div>
        <div className="col">
          <label htmlFor="input5" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Sub Category Image
          </label>
          <input
            type="file"
            className="form-control"
            id="formFile"
            onChange={(e) =>
              setUpdatedForm({ ...updatedForm, sub_category_image: e.target.files[0] })
            }
            name="profile"
            style={{ borderRadius: "10px", height: "50px" }}
          />
        </div>
      </div>
      <br />
      <div className="text-center">
    
          <button
            className="btn btn-success"
            style={{ borderRadius: "10px", float: "right", marginTop: "6px" }}
          >
            Update
          </button>
      </div>
    </form>
    <button
      className="btn btn-danger"
      onClick={() => setUpdate(false)}
      style={{ borderRadius: "10px", float: "right", marginRight: "5px" }}
    >
      Cancel
    </button>
  </Modal.Body>
</Modal>



            {/* </div> */}
       </Layout></>

        
    )
}

export default CreateSubCategory;